// @flow

import p400Image from './p400-small-transparent.png';
import chipperImage from './bbpos-chipper-small-transparent.png';
import wisepad3Image from './bbpos-wisepad-3-small-transparent.png';
import wisepos_eImage from './bbpos-wisepos-e-small-transparent.png';
import stripe_m2Image from './stripe-m2-small-transparent.png';

export const getReaderImageLink = (reader: string) => {
  return {
    p400: p400Image,
    chipper: chipperImage,
    wisepad3: wisepad3Image,
    wisepos_e: wisepos_eImage,
    stripe_m2: stripe_m2Image,
  }[reader];
};
